module.exports=function(scope){ return `<li class="mdl-list__item asseco-window-chat-error-message">
    <span class="mdl-list__item-primary-content">
        <span style="width: 100%;">${scope.message}</span>
    </span>
</li>`};